import React, { useContext, useEffect, useLayoutEffect, useState, useCallback, useRef } from "react";
import TopToolbar from "./Toolbar/TopToolbar";
import ToolbarMoreMenuRow from "./Toolbar/ToolbarMoreMenuRow";
import DeepTek from "../../../assets/DeepTek.png";
import OutlineButton from "./Tools/ToolComponents/OutlineButton";
import studyviewerContext from "../../../context/studyviewer/StudyviewerContext";
import HeatMapButton from "./Tools/ToolComponents/HeatMapButton";
import ShowOriginal from "./Tools/ToolComponents/ShowOriginal";
import { TooltipDelay, TooltipHost } from "@fluentui/react/lib/Tooltip";
import { useId } from "@fluentui/react-hooks";
//added for quality flag
import useImageQuality from "../../../hooks/useImageQuality";
import QualityIcon from "../../../components/QualityIcon/QualityIcon";
import Attention from "../../../components/SVGComponents/Attention";
import {
  ADVANCE_VIEWER_MODALITIES,
  ADVANCE_VIEWER_URL,
  BASIC_VIEWER_URL,
  COMPARE_TOOL_OBJECT,
  DEFAULT_TOOL,
  MPR_TOOL_OBJECT,
  REACT_ADVANCE_VIEWER_URL,
  REPORTDONESTATUS,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  US,
  USERTYPES,
  VDCLIMS,
  showPathologyForModalities,
} from "../../../constants/Constants";
import { DefaultButton, DirectionalHint, Icon, PrimaryButton } from "@fluentui/react";
import CustomSpinner from "../../../components/CustomSpinner";
import { useTranslation } from "react-i18next";
import {
  downloadStudyZip,
  _base64ToArrayBuffer,
} from "../../../service/StudyViewerService";
import ThumbnailContext from "../../../context/studyviewer/ThumbnailContext";
import ViewportContext from "../../../context/studyviewer/ViewportContext";
import ReportIcon from "../../../components/SVGComponents/ReportIcon";
import AddPathologyIcon from "../../../components/SVGComponents/AddPathologyIcon";
import AnnotationBox from "../../Annotations/components/AnnotationBox/AnnotationBox";
import "../styles/styles.css";
import ChevronDownIcon from "../../../components/SVGComponents/ChevronDownIcon";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import AttachmentIcon from "../../../components/SVGComponents/AttachmentIcon";
import AttachmentBox from "./AttachmentBox/AttachmentBox";
import ClinicalNotesIcon from "../../../components/SVGComponents/ClinicalNotesIcon";
import LockStudyTopBarIcon from "../../../components/SVGComponents/LockStudyTopBarIcon";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import DownloadButton from "./Tools/ToolComponents/DownloadButton";
import Augmento from "../../../components/SVGComponents/Logo/Augmento";
import DeeptekLogo from "../../../components/SVGComponents/Logo/DeeptekLogo";
import ShareStudyLink from "../../StudyList/components/Actions/ShareStudyLink";
import ShareIcon from "../../../components/SVGComponents/ShareIcon";
import ShareStudyContext from "../../../context/sharestudy/ShareStudyContext";
import { isMobile } from "react-device-detect";
import Back from "../../../components/SVGComponents/Tools/Back";
import themeContext from "../../../context/theme/ThemeContext";
import Tool from "./Tools/ToolComponents/Tool";
import userContext from "../../../context/users/UserContext";
import MPRToolComponent from "./Tools/ToolComponents/MPRToolComponent";
import BasicViewerSwitch from "../../../components/SVGComponents/BasicViewerSwitch";
import AdvanceViewerSwitch from "../../../components/SVGComponents/Tools/AdvanceViewerSwitch";
import { getPaymentStatusOfStudy } from "../../../service/StudyListService";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import { toolTipStyles } from "../styles/styles";
import toolStyle from "@cornerstonejs/tools/annotation/config/ToolStyle";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import LockStudy from "./LockStudy/LockStudy";
import More from "../../../components/SVGComponents/Tools/More";
import VerticalMore from "../../../components/SVGComponents/Tools/VerticalMore";
import MobileViewerContext from "../../../context/studyviewer/MobileViewerContext";
import TypistAccessCode from "../../StudyList/components/Typist/TypistAccessCode";
import { CropIcon, KeyboardClassicIcon } from "@fluentui/react-icons-mdl2";
import { getViewport, resizeViewport } from "../helpers/CornerstoneViewportService";
import { opneWeasisViewer } from "../../../helpers/CommonUtility";
import MicToolComponent from "./Tools/ToolComponents/MicToolComponent";
import KeyImage from "../../../components/SVGComponents/Tools/KeyImage";
import AdvKeyImagesModal from "./AdvKeyImagesModal/AdvKeyImagesModal";
import { RectangleROITool, StackScrollTool } from "@cornerstonejs/tools";
import { eventTarget } from "@cornerstonejs/core";
import { Enums, annotation } from "@cornerstonejs/tools";
import { isLLMAgentPresent } from "../../../service/MaskImageService";
import RebrandingLogo from "../../../components/SVGComponents/Logo/RebrandingLogo";
import FullScreen from "../../../components/SVGComponents/Tools/FullScreen";
import { getEnv } from '../../../helpers/EnvHelper';


const csToolsEvents = Enums.Events;


const TopBar = (props) => {
  const {
    studyData,
    messageCount,
    patientStudyData,
    studyModality,
    studyHistoryData,
    studyClinicalNotesData,
    studyParentId,
    assignmentData,
    firmViewerId,
    setSwitchingToBasic,
    parentChildReportsObj,
    getMessageCount,
    studyParentAssignmentData,
    showAttachment,
    setShowAttachment,
    showClinicalNotes,
    setShowClinicalNotes,
    advViewerUser,
    isTypistWorkflowEnabled,
    typistShowHistory,
    showChats,
    setShowShortcutModal,
    basicWeasisUser,
    setBasicWeasisUser,
    isLandscape,
    reportMenu,
    setSeriesMenu,
    showAccountWarning,
    setShowAccountWarning,
    accountWarningText,
    showAiResult,
    showSavedReport,
    studyResponseData
  } = useContext(studyviewerContext);

  const { theme, themeName } = useContext(themeContext);
  const { studyErrors } = useImageQuality(studyResponseData);


    const { studyDescription } = useContext(studyReportContext);
  const [showManageAdvKeyImagesModal, setShowManageAdvKeyImagesModal] =  useState(false);
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const moreMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutsideMoreMenu = (event) => {
      if (moreMenuRef.current && !moreMenuRef.current.contains(event.target)) {
        setShowMoreMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutsideMoreMenu, true);
    return () => document.removeEventListener("click", handleClickOutsideMoreMenu, true);
  }, []);

  const toolBarFlex = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    margin : "0 5px"
  };
  
  const handleKeyImageClick = () => {
    setShowManageAdvKeyImagesModal(true);
  };
  const {
    disableAddPathology,
    setDisableAddPathology,
    isMPRActive,
    isChildStudyActive,
    showPriorStudyTopBar,
    viewportLoadingComplete,
    viewportDoubleClickIndex,
    setIsUserInfoClicked,
  } = useContext(ViewportContext);
  const isFullScreenMode = viewportDoubleClickIndex !== -1 && viewportDoubleClickIndex != null;
  const {
    showLockWarning,
    lockStudy,
    lockStudySupervisor,
    showLockButton,
    alreadyLocked,
    setShowReturnStudyModal,
    reportDoneStatusState,
    showCommunicationModal,
    setShowCommunicationModal,
  } = useContext(studyReportContext);

  const {
    setShowMobileReportModal, 
    openMoreOptions, 
    setOpenMoreOptions, 
    setShowHistory, 
    showHistory,
    setSlideReportOpen,
    slideReportOpen,  
    } = useContext(MobileViewerContext);

  const { activeModality, activeStudyId } = useContext(ThumbnailContext);
  const [changeLockIcon, setChangeLockIcon] = useState(false);

  const {
    roles,
    userId,
    authenticated,
    loadByUsername,
    username,
    isActiveData,
    privilegedFirmDoctor,
    enableLlmReport,
    qcReviewer,
  } = useContext(userContext);

  // Portrait mode: collapse the utility icons (viewer switch, typist, manage key
  // image, mic, shortcut info) into the "More" menu only once they'd actually
  // overflow the row — measured against a hidden clone of the same content, so
  // this tracks real available space instead of guessing a viewport breakpoint.
  const [collapseUtilityIcons, setCollapseUtilityIcons] = useState(false);
  const outerContainerRef = useRef(null);
  const logoRef = useRef(null);
  const toolbarContainerRef = useRef(null);
  const middleContainerRef = useRef(null);
  const rightContainerRef = useRef(null);
  const utilityIconsRef = useRef(null);
  const utilityIconsMeasureRef = useRef(null);

  useLayoutEffect(() => {
    if (isLandscape) {
      setCollapseUtilityIcons(false);
      return;
    }

    const checkFit = () => {
      const outerEl = outerContainerRef.current;
      const logoEl = logoRef.current;
      const middleEl = middleContainerRef.current;
      const rightEl = rightContainerRef.current;
      const utilityEl = utilityIconsRef.current;
      const utilityMeasureEl = utilityIconsMeasureRef.current;
      if (!outerEl || !logoEl || !middleEl || !rightEl || !utilityMeasureEl) return;

      // Measure against the space actually left beside the logo, not the
      // toolbar row's own clientWidth — once the row has already wrapped onto
      // its own line, flex-wrap lets it stretch to the full container width,
      // which would make it look like there's plenty of room even though it
      // doesn't fit next to the logo.
      const outerRect = outerEl.getBoundingClientRect();
      const logoRect = logoEl.getBoundingClientRect();
      const available = outerRect.right - logoRect.right;

      const middleWidth = middleEl.scrollWidth;
      const utilityVisibleWidth =
        utilityEl && utilityEl.style.display !== "none" ? utilityEl.offsetWidth : 0;
      const rightNonUtilityWidth = rightEl.scrollWidth - utilityVisibleWidth;
      const utilityNaturalWidth = utilityMeasureEl.offsetWidth;
      const neededIfExpanded = middleWidth + rightNonUtilityWidth + utilityNaturalWidth;

      const shouldCollapse = neededIfExpanded > available;
      setCollapseUtilityIcons((prev) => (prev === shouldCollapse ? prev : shouldCollapse));
      if (!shouldCollapse) setShowMoreMenu(false);
    };

    checkFit();

    const resizeObserver = new ResizeObserver(checkFit);
    if (outerContainerRef.current) resizeObserver.observe(outerContainerRef.current);
    window.addEventListener("resize", checkFit);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", checkFit);
    };
  }, [isLandscape, roles, studyModality, advViewerUser, basicWeasisUser, enableLlmReport, isTypistWorkflowEnabled, reportDoneStatusState]);
  useEffect(() => {
    if (!showMoreMenu) {
      setShowAttachment(false);
      setShowClinicalNotes(false);
    }
  }, [showMoreMenu, collapseUtilityIcons]);

  const { showShareStudyLinkModal, setShowShareStudyLinkModal } =
    useContext(ShareStudyContext);
  
  const { cxrVersion } = useContext(studyviewerContext);

  const [paymentStatusOfStudy, setPaymentStatusOfStudy] = useState(0);
  const [paymentMessageOfStudy, setPaymentMessageOfStudy] = useState("");
  const [showPaymentAlertModal, setShowPaymentAlertModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showTypistModal, setShowTypistModal] = useState(false);
  const [isAppFullscreen, setIsAppFullscreen] = useState(false);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.warn("Fullscreen request failed:", err);
      });
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const onFullscreenChange = () => {
      setIsAppFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);

  const [t] = useTranslation();

  const { setActiveTool,cropAndDownloadFromAnnotation,activeViewportIndex , isCropEnable , setIsCropEnable} = useContext(ViewportContext);

  const handleStudyPaymentStatus = async () => {
    let studyId = studyParentId;
  try {
    const response = await getPaymentStatusOfStudy(studyId);
    if (response?.data?.result === "SUCCESS") {
      let status = response.data.data;
      if (status == VDCLIMS.PaymentStatusCodes.PAID) {
        setShowShareStudyLinkModal(true);
      } else {
        setPaymentStatusOfStudy(status);
        setPaymentMessageOfStudy(
          status == VDCLIMS.PaymentStatusCodes.DUE
            ? VDCLIMS.PAYMENT_MESSAGE_FOR_DUE
            : VDCLIMS.PAYMENT_MESSAGE_FOR_ERROR
        );
        setShowShareStudyLinkModal(false);
        setShowPaymentAlertModal(true);
        setShowConfirmModal(true);
      }
    } else {
      setPaymentStatusOfStudy(VDCLIMS.PaymentStatusCodes.ERROR);
      setPaymentMessageOfStudy(VDCLIMS.PAYMENT_MESSAGE_FOR_ERROR);
      setShowShareStudyLinkModal(false);
      setShowPaymentAlertModal(true);
      setShowConfirmModal(true);
    }
  } catch (err) {
      setPaymentStatusOfStudy(VDCLIMS.PaymentStatusCodes.ERROR);
      setPaymentMessageOfStudy(VDCLIMS.PAYMENT_MESSAGE_FOR_ERROR);
      setShowShareStudyLinkModal(false);
      setShowPaymentAlertModal(true);
      setShowConfirmModal(true);
    }
  };

  const handlePaymentAlertModal = () => {
    setShowPaymentAlertModal(false);
    setShowConfirmModal(false);
    setPaymentMessageOfStudy("");
    setPaymentStatusOfStudy(0);
  };

  const getStudyHistoryData = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyHistoryData;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.studyHistoryDocList != undefined
        ) {
          return parentChildReportsObj[activeStudyId]?.studyHistoryDocList;
        }
        return false;
      }
    }
  };

  const checkForHistoryDocsAvailable = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyHistoryData.length > 0;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.studyHistoryDocList != undefined
        ) {
          return (
            parentChildReportsObj[activeStudyId]?.studyHistoryDocList?.length >
            0
          );
        }
        return false;
      }
    }
  };

  const checkForClinicalNotesAvailable = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyClinicalNotesData.length > 0;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.history != undefined &&
          parentChildReportsObj[activeStudyId]?.history != null
        ) {
          return parentChildReportsObj[activeStudyId]?.history.length > 0;
        }
        return false;
      }
    }
  };

  const getStudyClinicalData = () => {
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyClinicalNotesData;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.history != undefined &&
          parentChildReportsObj[activeStudyId]?.history != null
        ) {
          return parentChildReportsObj[activeStudyId]?.history;
        }
        return false;
      }
    }
  };

useEffect(() =>{
  if(basicWeasisUser){
  opneWeasisViewer(studyParentId);
 }
},[basicWeasisUser]);

useEffect(() =>{
  // document.documentElement.style.setProperty( '--topbar-container-height', isLandscape ? '7.5%' : '4%' );
  document.documentElement.style.setProperty( '--topbar-container-height', isLandscape ? (isMobile ? '48px' : '7.5%') : (isMobile ? '5.5%' : '90px') );
},[isLandscape]);
  // useEffect(()=>{
  //   if(activeStudyId != "" && studyParentId != null && studyParentId != undefined){
  //       getMessageCount(activeStudyId);
  //   }
  // },[activeStudyId])

 const getstudyviewerBaseurl = () =>{
  const isAdvancedViewer = ADVANCE_VIEWER_MODALITIES.includes(studyModality) && advViewerUser;
  return isAdvancedViewer ? ADVANCE_VIEWER_URL : BASIC_VIEWER_URL;
  
 }


 let offset = 0;

 let toggle = false;
 function animateDashes(annotationUID) {
  //  offset = (offset + 1) % 10; // Keep offset small and cyclic
  //  toggle = !toggle;
  //  console.log("toggle value ", toggle);
   
  toolStyle.setAnnotationStyles(annotationUID, {
    lineWidth: "1px",
    textBoxLinkLineWidth: "0",
    textBoxFontSize: "0px",
    color: "#ffffff",
    colorSelected: "#ffffff",
    colorHighlighted: "#ffffff",
   
    lineDash:[5, 5] 
  });
  



  // requestAnimationFrame(() => animateDashes(annotationUID));
}




 const getSwitchViewerTitle =() =>{
  if( getEnv("REACT_APP_VDC_PLATFORM") == "true" ){
      if(advViewerUser){
        return "Switch to Advance Viewer";
      }else{
        return "Switch to Basic Viewer";
      }
  }
 
  return window.location.href.includes(
    "nonXrayAdvanceViewer"
  )
    ? "Switch to Basic Viewer"
    : "Switch to Advance Viewer"
}

  if (isMobile) {
    return (
      <>
        <div
          className="topbar-container w100"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="topbar-buttons">
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                padding: "0px 5px",
              }}
              onClick={() => window.close()}
            >
              <Back />
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                paddingLeft: "6px",
              }}
            >
              {/* <Augmento /> */}
              <RebrandingLogo fallback={<DeeptekLogo darkTheme={true} />} />
            </div>
          </div>
          <div
            className="topbar-buttons cursor-pointer"
            style={{
              paddingRight: "6px",
            }}
          >
            <TopToolbar
              openSeries={props.openSeries}
              seriesMenu={props.seriesMenu}
            />
            <LockStudy
                changeLockIcon={changeLockIcon}
                setChangeLockIcon={setChangeLockIcon}
              />
            {!(enableLlmReport && isLLMAgentPresent(studyModality, studyDescription)) && (
              <div
                className="topbar-buttons cursor-pointer"
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: "6px",
                }}
              >
                <MicToolComponent />
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "var(--mobile-color-txt)",
                    marginTop: "5px",
                  }}
                >
                  Voice
                </span>
              </div>
            )}
            {(roles[0] == USERTYPES.RADIOLOGIST ||
              roles[0] === USERTYPES.SUPERVISOR ||
              roles[0] == USERTYPES.FIRMADMIN) &&
              accountWarningText &&
              accountWarningText.trim() !== "" && (
                <div
                  className="topbar-buttons cursor-pointer"
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "6px",
                  }}
                  onClick={() => setShowAccountWarning(true)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "20px",
                      height: "20px",
                      color: "#ff8c00",
                    }}
                  >
                    <Attention />
                  </span>
                  <span
                    style={{
                      fontSize: "9px",
                      lineHeight: "100%",
                      fontWeight: "400",
                      color: "var(--mobile-color-txt)",
                      marginTop: "5px",
                    }}
                  >
                    Alert
                  </span>
                </div>
              )}
            {!roles[0].includes(USERTYPES.FIRMDOCTOR) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN) && isMobile && !isFullScreenMode && (
            <div
                className="topbar-buttons cursor-pointer"
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: "6px", // match others
                }}
                //onClick={() => setSlideReportOpen(prev => !prev)}
                onClick={() => {
                  setIsUserInfoClicked(false);
                  setOpenMoreOptions(false);
                  setShowHistory(false);
                  setSlideReportOpen((prev) => {
                    if (!prev) setSeriesMenu(false); // Close series
                    return !prev;
                  });
                }}
                >
                <ReportIcon
                //color={theme.palette.inactiveTool}
                color={slideReportOpen ? theme.palette.activeTool : theme.palette.inactiveTool}

                
                />
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "var(--mobile-color-txt)",
                    marginTop: "1px",
                  }}
                >
                  Report
                </span>
              </div>
              )}
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "6px",
              }}
              onClick={() => setShowCommunicationModal({ show: true, studyId: studyParentId })}
            >
              <ChatIcon 
                color={theme.palette.inactiveTool}
                active={showCommunicationModal} />
              {messageCount > 0 && (
                <span
                  className="message-count-tag"
                  style={{ top: "-2px", right: "7px" }}
                ></span>
              )}
              {isMobile && (
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                    marginTop: "5px",
                  }}
                >
                  Chat
                </span>
              )}
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "6px",
              }}
              onClick={() => {
                if (!showHistory) {
                  setOpenMoreOptions(false);
                  setSlideReportOpen(false);
                }
                setShowHistory((prev) => !prev);
              }}
            >
              <span className="topbar-toolbar-right-icons">
                <AttachmentIcon
                  color={theme.palette.inactiveTool}
                  active={showAttachment}
                />
                {checkForHistoryDocsAvailable() && !showAttachment && (
                  <span className="default-show-dot"></span>
                )}
              </span>
              {isMobile && (
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                    marginTop: "7px",
                  }}
                >
                  History
                </span>
              )}
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
              }}
              onClick={() => {
                setIsUserInfoClicked(false);
                if (!openMoreOptions) {
                  setShowHistory(false);
                  setSlideReportOpen(false);
                }
                setOpenMoreOptions((prev) => !prev);
              }}
            >
              <VerticalMore />
              {isMobile && (
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                    marginTop: "7px",
                  }}
                >
                  More
                </span>
              )}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    const utilityIconsContent = (
      <>
        { getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
          getEnv("REACT_APP_HYBRID_MODE") == "true" &&
          (!ADVANCE_VIEWER_MODALITIES.includes(studyModality)  || !advViewerUser ) &&(
            <span
              style={{
                display: "flex",
                margin: "0px 5px",
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => {
                setSwitchingToBasic((prev) => !prev);
                window.open(
                  getstudyviewerBaseurl() +
                    studyParentId +
                    "?firmId=" +
                    firmViewerId,
                  "_self"
                );
              }}
            >
              <div className="highlight-tool">
                <CustomToolTipHost
                  content={getSwitchViewerTitle()}
                  id="basic-viewer"
                >
                  <span className="topbar-toolbar-right-icons">
                    <BasicViewerSwitch />
                  </span>
                </CustomToolTipHost>
              </div>
            </span>
          )}
        { basicWeasisUser!= null && (basicWeasisUser == true || basicWeasisUser == 'true') && (
            <span
              style={{
                display: "flex",
                margin: "0px 5px",
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => {
                opneWeasisViewer(studyParentId)
              }}
            >
              <div className="highlight-tool">
                <CustomToolTipHost
                  content={t("heading.open-advance-viewer")}
                  id="basic-viewer"
                >
                  <span className="topbar-toolbar-right-icons">
                    <BasicViewerSwitch />
                  </span>
                </CustomToolTipHost>
              </div>
            </span>
          )}
        {advViewerUser && (ADVANCE_VIEWER_MODALITIES.includes(studyModality) || (getEnv("REACT_APP_VDC_PLATFORM") !== "true" && studyModality.toUpperCase() === US.toUpperCase())) && (
          <span
            style={{
              display: "flex",
              margin: "0px 5px",
              cursor: "pointer",
              position: "relative",
            }}
            onClick={() => {
              window.open(
                REACT_ADVANCE_VIEWER_URL +
                  studyParentId +
                  "?firmId=" +
                  firmViewerId,
                "_self"
              );
            }}
          >
            <div className="highlight-tool">
              <CustomToolTipHost
                content={t("heading.switch-to-advance-viewer")}
                id="basic-viewer"
              >
                <span className="topbar-toolbar-right-icons">
                  <AdvanceViewerSwitch
                    color={theme.palette.inactiveTool}
                  />
                </span>
              </CustomToolTipHost>
            </div>
          </span>
        )}

        {roles[0] == USERTYPES.RADIOLOGIST &&
          (reportDoneStatusState == REPORTDONESTATUS.SAVED ||
            reportDoneStatusState == REPORTDONESTATUS.UNREPORTED) &&
            (isTypistWorkflowEnabled==1 || isTypistWorkflowEnabled==2) && (
            <div
              className="topbar-toolbar-share-study-modal-container cursor-pointer"
              onClick={() => setShowTypistModal(true)}
            >
              <CustomToolTipHost
                delay={TooltipDelay.zero}
                id={"Assign Typist"}
                directionalHint={DirectionalHint.rightCenter}
                styles={toolTipStyles}
                content={t("heading.typist")}
              >
                <div className="highlight-tool">
                  <KeyboardClassicIcon
                    color={theme.palette.inactiveTool}
                  />
                </div>
              </CustomToolTipHost>
            </div>
          )}

        {/* here key images pop */}
        <CustomToolTipHost
          content={t("key-image.manage-key-image")}
          id="key-images"
        >
          <div className="highlight-tool cursor-pointer" onClick={handleKeyImageClick}>
            <KeyImage color={theme.palette.activeTool} />
          </div>
        </CustomToolTipHost>

        { !(enableLlmReport && isLLMAgentPresent(studyModality, studyDescription)) &&
          <div className="highlight-tool cursor-pointer">
            <MicToolComponent />
          </div>
        }
        <LockStudy
          changeLockIcon={changeLockIcon}
          setChangeLockIcon={setChangeLockIcon}
        />
        <div className="highlight-tool cursor-pointer" onClick={() => setShowShortcutModal(true)}>
          <CustomToolTipHost content={t("heading.shortcut-info")} id="Shortcut">
            <span className="topbar-toolbar-right-icons">
              <Icon
                iconName="info"
                style={{ fontSize: "18px", marginTop: "2px", color: theme.palette.inactiveTool }}
              />
            </span>
          </CustomToolTipHost>
        </div>
        { ((roles[0] == USERTYPES.TYPIST && typistShowHistory) || roles[0] != USERTYPES.TYPIST) && <>
        <span
          className="topbar-toolbar-history"
          style={{
            cursor: checkForHistoryDocsAvailable()
              ? "pointer"
              : "not-allowed",
          }}
          onClick={() => {
            if (checkForHistoryDocsAvailable()) setShowAttachment(true);
          }}
        >
          <span
            style={{
              display: "flex",
              cursor: checkForHistoryDocsAvailable()
                ? "pointer"
                : "not-allowed",
              position: "relative",
            }}
            onClick={() => {
              if (checkForHistoryDocsAvailable()) setShowAttachment(true);
            }}
          >
            <div className="highlight-tool">
              <CustomToolTipHost
                content={
                  checkForHistoryDocsAvailable()
                    ? t("heading.attachment")
                    : t("search-message.no-attachment")
                }
                id="Attachment"
              >
                <span className="topbar-toolbar-right-icons">
                  <AttachmentIcon
                    color={theme.palette.inactiveTool}
                    active={showAttachment}
                  />
                  {checkForHistoryDocsAvailable() && !showAttachment && (
                    <span className="default-show-dot"></span>
                  )}
                </span>
              </CustomToolTipHost>
            </div>
            <div>
              {!collapseUtilityIcons && (
                <AttachmentBox
                  boxName="history"
                  show={showAttachment}
                  onClickOutside={() => {
                    setShowAttachment(false);
                  }}
                  setShowPathologyOptions={props.setShowPathologyOptions}
                  setShowInfo1={showAttachment}
                  studyHistoryData={getStudyHistoryData()}
                />
              )}
            </div>
          </span>
        </span>

        <span
          className="topbar-toolbar-history"
          style={{
            cursor: checkForClinicalNotesAvailable()
              ? "pointer"
              : "not-allowed",
          }}
          onClick={() => {
            checkForClinicalNotesAvailable() &&
              setShowClinicalNotes(true);
          }}
        >
          <div className="highlight-tool">
            <CustomToolTipHost
              content={
                checkForClinicalNotesAvailable()
                  ? t("heading.clinical-notes")
                  : t("search-message.no-clinical-notes")
              }
              id="ClinicalNotes"
            >
              <span className="topbar-toolbar-right-icons">
                <ClinicalNotesIcon
                  color={theme.palette.inactiveTool}
                  active={showClinicalNotes}
                />
                {checkForClinicalNotesAvailable() &&
                  !showClinicalNotes && (
                    <span className="default-show-dot"></span>
                  )}
              </span>
            </CustomToolTipHost>
          </div>
          <div>
            {!collapseUtilityIcons && (
              <AttachmentBox
                boxName="notes"
                show={showClinicalNotes}
                onClickOutside={() => {
                  setShowClinicalNotes(false);
                }}
                setShowPathologyOptions={props.setShowPathologyOptions}
                setShowInfo1={showClinicalNotes}
                studyClinicalNotesData={getStudyClinicalData()}
              />
            )}
          </div>
        </span>
        </>}
      </>
    );

    // Inert stand-in for utilityIconsContent used only to measure its natural
    // width (see utilityIconsMeasureRef below). Mirrors the same conditions and
    // box sizes without mounting the real interactive icons a second time —
    // MicToolComponent in particular opens a mic stream/websocket on mount, so
    // rendering the live content twice would start a second recording session.
    const utilityIconsMeasureContent = (
      <>
        { getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
          getEnv("REACT_APP_HYBRID_MODE") == "true" &&
          (!ADVANCE_VIEWER_MODALITIES.includes(studyModality)  || !advViewerUser ) && (
            <span style={{ display: "flex", margin: "0px 5px" }}>
              <div className="highlight-tool" />
            </span>
          )}
        { basicWeasisUser!= null && (basicWeasisUser == true || basicWeasisUser == 'true') && (
            <span style={{ display: "flex", margin: "0px 5px" }}>
              <div className="highlight-tool" />
            </span>
          )}
        {advViewerUser && (ADVANCE_VIEWER_MODALITIES.includes(studyModality) || (getEnv("REACT_APP_VDC_PLATFORM") !== "true" && studyModality.toUpperCase() === US.toUpperCase())) && (
          <span style={{ display: "flex", margin: "0px 5px" }}>
            <div className="highlight-tool" />
          </span>
        )}
        {roles[0] == USERTYPES.RADIOLOGIST &&
          (reportDoneStatusState == REPORTDONESTATUS.SAVED ||
            reportDoneStatusState == REPORTDONESTATUS.UNREPORTED) &&
            (isTypistWorkflowEnabled==1 || isTypistWorkflowEnabled==2) && (
            <div className="topbar-toolbar-share-study-modal-container">
              <div className="highlight-tool" />
            </div>
          )}
        <div className="highlight-tool" />
        { !(enableLlmReport && isLLMAgentPresent(studyModality, studyDescription)) &&
          <div className="highlight-tool" />
        }
        {/* Lock Study's own visibility rules aren't duplicated here — this
            conservatively assumes it may show, which only risks collapsing
            slightly earlier than strictly necessary. */}
        <div className="highlight-tool" />
        <div className="highlight-tool" />
        { ((roles[0] == USERTYPES.TYPIST && typistShowHistory) || roles[0] != USERTYPES.TYPIST) && <>
          <div className="highlight-tool" />
          <div className="highlight-tool" />
        </>}
      </>
    );

    return (
      <>
        <div className={`topbar-container w100${!isLandscape ? ' topbar-portrait' : ''}`} ref={outerContainerRef}>
          <div className="topbar-augmento-logo " ref={logoRef}>
            {/* <Augmento /> */}
            <RebrandingLogo fallback={<DeeptekLogo darkTheme={true} />} />
          </div>
          <div className="topbar-toolbar-container" ref={toolbarContainerRef}>
            {isLandscape && (
              <div
                className={`topbar-toolbar-left-container ${
                  !viewportLoadingComplete && "disable-toolbar"
                }`}
              >
                <TopToolbar
                  openSeries={props.openSeries}
                  seriesMenu={props.seriesMenu}
                />
              </div>
            )}
            <div className="topbar-toolbar-middle-container" ref={middleContainerRef}>
              {props.priors && <Tool tool={COMPARE_TOOL_OBJECT} />}
              {!MPR_TOOL_OBJECT.NotFor.includes(activeModality) && (
                // <Tool tool={MPR_TOOL_OBJECT} />
                <MPRToolComponent />
              )}
              {(showPathologyForModalities.includes(studyModality) ||
                showPriorStudyTopBar) &&
                roles.length > 0 && ((!roles[0].includes(USERTYPES.FIRMDOCTOR) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN)) || showAiResult) && !isFullScreenMode && (
                  <div style={{ display: "flex" }}>
                    <PathologyButton
                      setShowPathologyOptions={props.setShowPathologyOptions}
                      showPathologyOptions={props.showPathologyOptions}
                    />
                  </div>
                )}

              {!SHOW_NOT_ORIGNAL_MODALITY_LIST.includes(activeModality) && (
                <ShowOriginal />
              )}
              <div id="timerDisplayOnReportingPanel" className = "expiration-timer-container" style={{display:"none"}}>
                <span id="reportTimerText" className = "expiration-timer-text" ></span>
              </div>
            </div>

            <div className="topbar-toolbar-right-container h100" style={{ display: 'flex', alignItems: 'center', position: 'relative' }} ref={rightContainerRef}>
              <div
                className="topbar-right-utility-icons"
                ref={utilityIconsRef}
                style={{ display: collapseUtilityIcons ? "none" : "flex" }}
              >
                {utilityIconsContent}
              </div>
              {/* Hidden clone: measures the utility icons' natural width so we know
                  when they no longer fit and should collapse into the More menu,
                  regardless of whether the visible copy above is currently shown.
                  Uses inert placeholders (utilityIconsMeasureContent), not the real
                  icons, so nothing gets mounted/wired up twice. */}
              <div
                ref={utilityIconsMeasureRef}
                aria-hidden="true"
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "absolute",
                  visibility: "hidden",
                  pointerEvents: "none",
                  whiteSpace: "nowrap",
                  top: 0,
                  left: 0,
                }}
              >
                {utilityIconsMeasureContent}
              </div>
              {showManageAdvKeyImagesModal && (
                <AdvKeyImagesModal
                  showManageAdvKeyImagesModal={showManageAdvKeyImagesModal}
                  setShowManageAdvKeyImagesModal={setShowManageAdvKeyImagesModal}
                  studyId={studyParentId}
                />
              )}

              <div
                className="topbar-more-menu-btn"
                ref={moreMenuRef}
                style={{ display: collapseUtilityIcons ? "flex" : "none" }}
              >
                <div
                  className="highlight-tool cursor-pointer"
                  onClick={() => setShowMoreMenu((prev) => !prev)}
                >
                  <More />
                </div>
                <div
                  className="viewer-tool-more-dropdown viewer-toolbar-more-menu"
                  style={{
                    display: showMoreMenu ? "flex" : "none",
                    flexDirection: "column",
                    position: "absolute",
                    top: "100%",
                    // OLD: right: 0,
                    left: 0,
                    marginTop: "4px",
                    zIndex: 9999,
                    minWidth: "220px",
                    whiteSpace: "nowrap",
                    boxShadow:
                      "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
                    borderRadius: "5px",
                  }}
                >
                  { getEnv("REACT_APP_VDC_PLATFORM") === "true" &&
                    getEnv("REACT_APP_HYBRID_MODE") == "true" &&
                    (!ADVANCE_VIEWER_MODALITIES.includes(studyModality)  || !advViewerUser ) &&(
                      <ToolbarMoreMenuRow
                        label={getSwitchViewerTitle()}
                        onClick={() => {
                          setShowMoreMenu(false);
                          setSwitchingToBasic((prev) => !prev);
                          window.open(
                            getstudyviewerBaseurl() +
                              studyParentId +
                              "?firmId=" +
                              firmViewerId,
                            "_self"
                          );
                        }}
                      >
                        <div className="highlight-tool">
                          <BasicViewerSwitch />
                        </div>
                      </ToolbarMoreMenuRow>
                    )}
                  { basicWeasisUser!= null && (basicWeasisUser == true || basicWeasisUser == 'true') && (
                      <ToolbarMoreMenuRow
                        label={t("heading.open-advance-viewer")}
                        onClick={() => {
                          setShowMoreMenu(false);
                          opneWeasisViewer(studyParentId);
                        }}
                      >
                        <div className="highlight-tool">
                          <BasicViewerSwitch />
                        </div>
                      </ToolbarMoreMenuRow>
                    )}
                  {advViewerUser && (ADVANCE_VIEWER_MODALITIES.includes(studyModality) || (getEnv("REACT_APP_VDC_PLATFORM") !== "true" && studyModality.toUpperCase() === US.toUpperCase())) && (
                    <ToolbarMoreMenuRow
                      label={t("heading.switch-to-advance-viewer")}
                      onClick={() => {
                        setShowMoreMenu(false);
                        window.open(
                          REACT_ADVANCE_VIEWER_URL +
                            studyParentId +
                            "?firmId=" +
                            firmViewerId,
                          "_self"
                        );
                      }}
                    >
                      <div className="highlight-tool">
                        <AdvanceViewerSwitch color={theme.palette.inactiveTool} />
                      </div>
                    </ToolbarMoreMenuRow>
                  )}
                  {roles[0] == USERTYPES.RADIOLOGIST &&
                    (reportDoneStatusState == REPORTDONESTATUS.SAVED ||
                      reportDoneStatusState == REPORTDONESTATUS.UNREPORTED) &&
                      (isTypistWorkflowEnabled==1 || isTypistWorkflowEnabled==2) && (
                      <ToolbarMoreMenuRow
                        label={t("heading.typist")}
                        onClick={() => {
                          setShowMoreMenu(false);
                          setShowTypistModal(true);
                        }}
                      >
                        <div className="highlight-tool">
                          <KeyboardClassicIcon color={theme.palette.inactiveTool} />
                        </div>
                      </ToolbarMoreMenuRow>
                    )}
                  <ToolbarMoreMenuRow
                    label={t("key-image.manage-key-image")}
                    onClick={() => {
                      setShowMoreMenu(false);
                      handleKeyImageClick();
                    }}
                  >
                    <div className="highlight-tool">
                      <KeyImage color={theme.palette.activeTool} />
                    </div>
                  </ToolbarMoreMenuRow>
                  { !(enableLlmReport && isLLMAgentPresent(studyModality, studyDescription)) &&
                    <ToolbarMoreMenuRow
                      label={t("heading.mic-start")}
                      onClick={() => setShowMoreMenu(false)}
                    >
                      <div className="highlight-tool">
                        <MicToolComponent />
                      </div>
                    </ToolbarMoreMenuRow>
                  }
                  <LockStudy
                    variant="menu"
                    changeLockIcon={changeLockIcon}
                    setChangeLockIcon={setChangeLockIcon}
                    onSelect={() => setShowMoreMenu(false)}
                  />
                  <ToolbarMoreMenuRow
                    label={t("heading.shortcut-info")}
                    onClick={() => {
                      setShowMoreMenu(false);
                      setShowShortcutModal(true);
                    }}
                  >
                    <div className="highlight-tool">
                      <Icon
                        iconName="info"
                        style={{ fontSize: "18px", color: theme.palette.inactiveTool }}
                      />
                    </div>
                  </ToolbarMoreMenuRow>
                  { ((roles[0] == USERTYPES.TYPIST && typistShowHistory) || roles[0] != USERTYPES.TYPIST) && <>
                  <div
                    className="viewer-toolbar-more-menu-row"
                    style={{ cursor: checkForHistoryDocsAvailable() ? "pointer" : "not-allowed" }}
                    onClick={() => {
                      if (checkForHistoryDocsAvailable()) {
                        // closed the menu and floated the popup outside it.
                        // setShowMoreMenu(false);
                        // setShowAttachment(true);
                        // NEW: keep the menu open and expand the list in place,
                        // as a section of the dropdown.
                        setShowClinicalNotes(false);
                        setShowAttachment((prev) => !prev);
                      } else {
                        console.warn(
                          "[more-menu][history-attachment] row clicked but no history docs available - row stays disabled"
                        );
                      }
                    }}
                  >
                    <div className="viewer-toolbar-more-menu-leading">
                      <span className="topbar-toolbar-history viewer-toolbar-more-menu-icon">
                        <div className="highlight-tool">
                          <AttachmentIcon
                            color={theme.palette.inactiveTool}
                            active={showAttachment}
                          />
                          {checkForHistoryDocsAvailable() && !showAttachment && (
                            <span className="default-show-dot"></span>
                          )}
                        </div>
                        {/*
                        <AttachmentBox
                          boxName="history"
                          show={showAttachment}
                          onClickOutside={() => {
                            setShowAttachment(false);
                          }}
                          setShowPathologyOptions={props.setShowPathologyOptions}
                          setShowInfo1={showAttachment}
                          studyHistoryData={getStudyHistoryData()}
                        />
                        */}
                      </span>
                      {/* OLD: label flipped between "Attachment" and "No attachment".
                      <span className="viewer-toolbar-more-menu-label">
                        {checkForHistoryDocsAvailable()
                          ? t("heading.attachment")
                          : t("search-message.no-attachment")}
                      </span>
                      */}
                      {/* NEW: always "History attachment" (renamed on request). The row is
                          still not clickable when nothing is uploaded, so it is dimmed --
                          the old label was what used to convey the empty state. */}
                      <span
                        className="viewer-toolbar-more-menu-label"
                        style={{
                          opacity: checkForHistoryDocsAvailable() ? 1 : 0.5,
                        }}
                      >
                        {t("heading.history-attachment")}
                      </span>
                    </div>
                  </div>
                  {showAttachment && checkForHistoryDocsAvailable() && (
                    <AttachmentBox
                      boxName="history"
                      inline
                      disableClickOutside
                      show={showAttachment}
                      setShowPathologyOptions={props.setShowPathologyOptions}
                      setShowInfo1={showAttachment}
                      studyHistoryData={getStudyHistoryData()}
                    />
                  )}

                  <div
                    className="viewer-toolbar-more-menu-row"
                    style={{ cursor: checkForClinicalNotesAvailable() ? "pointer" : "not-allowed" }}
                    onClick={() => {
                      if (checkForClinicalNotesAvailable()) {
                        // closed the menu and floated the popup outside it.
                        // setShowMoreMenu(false);
                        // setShowClinicalNotes(true);
                        // NEW: expand in place, same as the History row.
                        console.warn(
                          "[more-menu][clinical-notes] toggling inline panel inside the More menu"
                        );
                        setShowAttachment(false);
                        setShowClinicalNotes((prev) => !prev);
                      } else {
                        console.warn(
                          "[more-menu][clinical-notes] row clicked but no clinical notes available - row stays disabled"
                        );
                      }
                    }}
                  >
                    <div className="viewer-toolbar-more-menu-leading">
                      <span className="topbar-toolbar-history viewer-toolbar-more-menu-icon">
                        <div className="highlight-tool">
                          <ClinicalNotesIcon
                            color={theme.palette.inactiveTool}
                            active={showClinicalNotes}
                          />
                          {checkForClinicalNotesAvailable() && !showClinicalNotes && (
                            <span className="default-show-dot"></span>
                          )}
                        </div>
                        {/*
                        <AttachmentBox
                          boxName="notes"
                          show={showClinicalNotes}
                          onClickOutside={() => {
                            setShowClinicalNotes(false);
                          }}
                          setShowPathologyOptions={props.setShowPathologyOptions}
                          setShowInfo1={showClinicalNotes}
                          studyClinicalNotesData={getStudyClinicalData()}
                        />
                        */}
                        {/* NEW: moved out of the dropdown -- see below. */}
                      </span>
                      {/* OLD: label flipped between "Clinical Notes" and "No clinical notes".
                      <span className="viewer-toolbar-more-menu-label">
                        {checkForClinicalNotesAvailable()
                          ? t("heading.clinical-notes")
                          : t("search-message.no-clinical-notes")}
                      </span>
                      */}
                      {/* NEW: always "Clinical Notes" (renamed on request). Dimmed when
                          there is nothing to open, same as the History attachment row. */}
                      <span
                        className="viewer-toolbar-more-menu-label"
                        style={{
                          opacity: checkForClinicalNotesAvailable() ? 1 : 0.5,
                        }}
                      >
                        {t("heading.clinical-notes")}
                      </span>
                    </div>
                  </div>

                  {/* NEW: clinical notes expanded in place, same as History above. */}
                  {showClinicalNotes && checkForClinicalNotesAvailable() && (
                    <AttachmentBox
                      boxName="notes"
                      inline
                      disableClickOutside
                      show={showClinicalNotes}
                      setShowPathologyOptions={props.setShowPathologyOptions}
                      setShowInfo1={showClinicalNotes}
                      studyClinicalNotesData={getStudyClinicalData()}
                    />
                  )}
                  </>}
                </div>

                {/* OLD: floated the two popups outside the dropdown, anchored on
                    .topbar-more-menu-btn. Replaced on request -- the list now expands
                    inside the More menu itself (see the inline AttachmentBox panels
                    under each row above), so the menu stays open while you pick a file.
                {collapseUtilityIcons &&
                  ((roles[0] == USERTYPES.TYPIST && typistShowHistory) ||
                    roles[0] != USERTYPES.TYPIST) && (
                    <span className="topbar-toolbar-history">
                      <AttachmentBox
                        boxName="history"
                        show={showAttachment}
                        onClickOutside={() => {
                          setShowAttachment(false);
                        }}
                        setShowPathologyOptions={props.setShowPathologyOptions}
                        setShowInfo1={showAttachment}
                        studyHistoryData={getStudyHistoryData()}
                      />
                      <AttachmentBox
                        boxName="notes"
                        show={showClinicalNotes}
                        onClickOutside={() => {
                          setShowClinicalNotes(false);
                        }}
                        setShowPathologyOptions={props.setShowPathologyOptions}
                        setShowInfo1={showClinicalNotes}
                        studyClinicalNotesData={getStudyClinicalData()}
                      />
                    </span>
                  )}
                */}
              </div>

              {(roles[0] == USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMADMIN)&& accountWarningText && accountWarningText.trim() !== "" &&(
                      <span
                        style={{
                          display: "flex",
                          margin: "0px 5px",
                          cursor: "pointer",
                          position: "relative",
                           alignItems: "center",
                            justifyContent: "center"
                        }}
                        onClick={() => {
                          setShowAccountWarning(true);
                        
                        }}
                      >
                        <div className="highlight-tool">
                          <CustomToolTipHost
                            content="Account Warning"
                            id="basic-viewer"
                          >
                            <span className="topbar-toolbar-right-icons"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "12px", 
                                width: "20px", 
                                height: "20px", 
                                color: "#ff8c00", 
                              }}
                            >
                                <Attention/>
                            </span>
                          </CustomToolTipHost>
                        </div>
                      </span>
                    )}

              {/* the Full Screen icon sat HERE (before this divider). ONLY the Full
                  Screen icon moved — to the LEFT of the Report button (see moved block below).
                  The divider that separates the left tools from the chat/download/share group
                  is kept (restored right after this comment).
              <div className="highlight-tool cursor-pointer" onClick={toggleFullscreen}>
                <CustomToolTipHost
                  content={isAppFullscreen ? "Exit Full Screen" : "Full Screen"}
                  id="fullscreen-toggle"
                >
                  <span className="topbar-toolbar-right-icons">
                    <FullScreen color={theme.palette.inactiveTool} isFullscreen={isAppFullscreen} />
                  </span>
                </CustomToolTipHost>
              </div>
              */}
              <div className="separator-topbar-items"></div>
              <div className="topbar-buttons">
                {((roles[0] == USERTYPES.TYPIST && showChats) || roles[0] != USERTYPES.TYPIST) && <div
                  className="topbar-toolbar-communication cursor-pointer"
                  onClick={() => setShowCommunicationModal(true)}
                >
                  <div className="highlight-tool">
                    <CustomToolTipHost content={t("label.chat")} id="Chat">
                      <span className="topbar-toolbar-right-icons">
                        <ChatIcon
                          //color={true}
                          color={theme.palette.inactiveTool}
                          active={showCommunicationModal}
                        />
                        {messageCount > 0 && !isChildStudyActive && (
                          <span className="message-count-tag"></span>
                        )}
                      </span>
                    </CustomToolTipHost>
                  </div>
                </div>}

                {
                  <div className="topbar-toolbar-communication-modal-container cursor-pointer">
                    <div className="highlight-tool">
                      <DownloadButton />
                    </div>
                  </div>
                }

                {showTypistModal && (
                  <TypistAccessCode
                    setShowTypistModal={setShowTypistModal}
                    studyId={studyParentId}
                  isTypistWorkflowEnabled={isTypistWorkflowEnabled}/>
                )}
                {showShareStudyLinkModal && (
                  <ShareStudyLink
                    studyId={studyParentId}
                    firmId={assignmentData.firmId}
                    clientId={assignmentData.clientId}
                  />
                )}
                {showPaymentAlertModal && (
                  <ConfirmModal
                    handleConfirm={handlePaymentAlertModal}
                    handleNotConfirm={handlePaymentAlertModal}
                    setShowConfirmModal={setShowConfirmModal}
                    showConfirmModal={showConfirmModal}
                    message={paymentMessageOfStudy}
                    title={t("confirm-message.alert")}
                    confirmButtonText={t("confirm-message.ok")}
                    cancelButtonText={t("confirm-message.cancel")}
                  />
                )}

                {isActiveData && (
                  <div
                    className="topbar-toolbar-share-study-modal-container cursor-pointer"
                    onClick={() => handleStudyPaymentStatus()}
                  >
                    <CustomToolTipHost
                      delay={TooltipDelay.zero}
                      id={"Share Study"}
                      directionalHint={DirectionalHint.rightCenter}
                      styles={toolTipStyles}
                      content={isMobile ? "" : t("share-study.title")}
                    >
                      <div className="highlight-tool">
                        <ShareIcon color={theme.palette.inactiveTool} />
                      </div>
                    </CustomToolTipHost>
                  </div>
                )}
              </div>

              {/* Full Screen moved here — to the LEFT of the Report button, with a
                  vertical divider to its right (between Full Screen and Report). The
                  Full Screen toggle itself stays available regardless of isFullScreenMode
                  (so you can exit); the divider only shows when the Report button shows. */}
              <div className="highlight-tool cursor-pointer" onClick={toggleFullscreen}>
                <CustomToolTipHost
                  content={isAppFullscreen ? "Exit Full Screen" : "Full Screen"}
                  id="fullscreen-toggle"
                >
                  <span className="topbar-toolbar-right-icons">
                    <FullScreen color={theme.palette.inactiveTool} isFullscreen={isAppFullscreen} />
                  </span>
                </CustomToolTipHost>
              </div>
              {/* {!isFullScreenMode && <div className="separator-topbar-items"></div>} */}

            {roles.length > 0 && ((!roles[0].includes(USERTYPES.FIRMDOCTOR) && !roles.includes(USERTYPES.FIRMTECHNICIAN)) || showSavedReport) && !isFullScreenMode && (
                <CustomToolTipHost content="Report" id="View Report">
                  <button
                    onClick={props.openReport}
                    className="view-report-primay-button"
                    style={{
                      background: reportMenu
                        ? "rgb(0, 120, 212)"
                        : "transparent",
                      border: reportMenu
                        ? "1px solid transparent"
                        : themeName != "light"
                        ? "1px solid #C3C4CD"
                        : "1px solid rgb(41 41 41)",
                    }}
                  >
                    <span style={{ display: "flex" , marginTop: "3px"}}>
                      <ReportIcon active={reportMenu} color={(reportMenu || themeName !== "light") ? "#FFF" : "#000"} />
                    </span>
                    <span className="view-report-button-text" style={{color:reportMenu || themeName !== "light"?"#FFF":"#000"}}>
                      {t("report-version.report")}
                    </span>
                  </button>
                </CustomToolTipHost>
              )}
            </div>
          </div>
          {!isLandscape && (
            <div className="topbar-portrait-tools-row">
              <div
                className={`topbar-toolbar-left-container ${
                  !viewportLoadingComplete && "disable-toolbar"
                }`}
              >
                <TopToolbar
                  openSeries={props.openSeries}
                  seriesMenu={props.seriesMenu}
                />
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
};

export default TopBar;

export const PathologyButton = (props) => {
  const { roles, authenticated, loadByUsername, username, enableLlmReport} =
    useContext(userContext);
  const [showInfo1, setShowInfo1] = useState(false);
  const { themeName,getAlterColor,theme ,getThemeColor} = useContext(themeContext);
  const {
    disableAddPathology,
    setDisableAddPathology,
    originalImageActiveState,
    activeViewportIndex,
  } = useContext(ViewportContext);
  const {cxrVersion} = useContext(studyviewerContext)

  const { isChildStudyActive } = useContext(ViewportContext);
  const [delayHandler, setDelayHandler] = useState(null);
  const { isClientReportExist, isWordFilePath, allReportTemplatesLoading } =
    useContext(studyReportContext);
  const [t] = useTranslation();

  const onHideContextualMenu = useCallback(() => setShowInfo1(false), []);

  const hideContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowInfo1(false);
      }, 300)
    );
  };

  const onShowContextualMenu = (ev) => {
    ev.preventDefault(); // don't navigate

    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowInfo1(true);
      }, 300)
    );
  };

  useEffect(() => {
    clearTimeout(hideContextMenu);
  }, [showInfo1]);

  return (
    <div
      className="pathology-button-topbar"
      onClick={() => {
        if (!isChildStudyActive)
          props.setShowPathologyOptions(!props.showPathologyOptions);
          let resizeInterval = setInterval(async () => {
            await resizeViewport();
          }, 200)
          setTimeout(() => {
            clearInterval(resizeInterval)
          }, 600)
      }}
      style={{
        background:
          props.showPathologyOptions && !isChildStudyActive && !isWordFilePath
            ? theme.palette.viewerButtonColor
            : isChildStudyActive || isWordFilePath
            ? "rgba(215, 214, 214, 0.57)"
            : "none",
        border: props.showPathologyOptions
          ? "1px solid transparent"
          : themeName != "light"
          ? "1px solid #C3C4CD"
          : "1px solid rgb(41 41 41)",
        cursor:
          !isChildStudyActive && !isWordFilePath ? "pointer" : "not-allowed",
      }}
    >
      {!cxrVersion && <div
        className="annotation-add-icon-topbar"
        onClick={(e) => {
          e.stopPropagation();
          if (
            !disableAddPathology &&
            roles[0] == USERTYPES.RADIOLOGIST &&
            !isChildStudyActive &&
            !isWordFilePath
          ) {
            setShowInfo1((prev) => !prev);
          }
        }}
        onMouseEnter={(ev) => {
          if (
            !disableAddPathology &&
            roles[0] == USERTYPES.RADIOLOGIST &&
            !isChildStudyActive &&
            !isWordFilePath
          ) {
            onShowContextualMenu(ev);
            // setShowInfo1(true);
          }
        }}
        onMouseLeave={(e) => {
          e.stopPropagation();
          hideContextMenu();
        }}
        style={{
          display:
            !disableAddPathology &&
            roles[0] == USERTYPES.RADIOLOGIST && 
            !allReportTemplatesLoading &&
            isClientReportExist != null &&
            !isClientReportExist
              ? "flex"
              : "none",
        }}
      >
        <AddPathologyIcon active={showInfo1} open={props.showPathologyOptions} isChildStudyActive={isChildStudyActive} />
        <div
          onMouseEnter={(ev) => {
            if (
              !disableAddPathology &&
              roles[0] == USERTYPES.RADIOLOGIST  &&
              !allReportTemplatesLoading &&
              isClientReportExist != null &&
              !isClientReportExist
            ) {
              onShowContextualMenu(ev);
            }
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
            hideContextMenu();
          }}
        >
          <AnnotationBox
            show={showInfo1}
            onClickOutside={() => {
              setShowInfo1(false);
            }}
            setShowPathologyOptions={props.setShowPathologyOptions}
            setShowInfo1={setShowInfo1}
          />
        </div>
      </div>}
      {!cxrVersion&& !disableAddPathology &&
        roles[0] == USERTYPES.RADIOLOGIST && 
        !allReportTemplatesLoading &&
        isClientReportExist != null &&
        !isClientReportExist && 
        <span className="border-topbar"
          style={{
            background: 
             props.showPathologyOptions && !isChildStudyActive && !isWordFilePath
             ? getThemeColor("border-topbar-active")
             : getThemeColor("border-topbar-inactive"),
          }}
        ></span>}
      <span style={{ color: props.showPathologyOptions && !isChildStudyActive && !isWordFilePath ? getAlterColor("#FFF","#FFF") : getAlterColor("#FFF","#000") }} className="pathology-text-topbar">
        {t("studyviewer.pathologies")}
      </span>
     
      {!cxrVersion && !disableAddPathology &&
        roles[0] == USERTYPES.RADIOLOGIST &&
        !allReportTemplatesLoading &&
        isClientReportExist != null &&
        !isClientReportExist && (
          // <span className="down-icon-topbar">
          //   <ChevronDownIcon />
          // </span>
        //   <span 
        //   className={`down-icon-topbar ${props.showPathologyOptions && !isChildStudyActive && !isWordFilePath 
        //     ? "icon-active" 
        //     : "icon-inactive"}`}
        // >
        <span 
          className="down-icon-topbar"
        >
          <ChevronDownIcon 
          color={props.showPathologyOptions && !isChildStudyActive && !isWordFilePath 
            ? getAlterColor("#FFF","#FFF") 
            : getAlterColor("#FFF","#000")
          }/>
          </span>
        )}

    </div>
  );
};
